import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "kambing-cup-livescore.firebaseapp.com",
  projectId: "kambing-cup-livescore",
  storageBucket: "kambing-cup-livescore.appspot.com",
  messagingSenderId: "410843135854",
  appId: "1:410843135854:web:43a343e639901657584b7f"
};

const app = initializeApp(firebaseConfig);

export const database = getDatabase(app);
export const auth = getAuth(app);